import { Controller } from "@hotwired/stimulus"

export default class extends Controller {
  static targets = ["tab", "panel"]
  static values = { initialIndex: Number }

  connect() { this.select(this.initialIndexValue === 1 ? 1 : 0) }

  change(event) { this.select(this.tabTargets.indexOf(event.currentTarget)) }

  navigate(event) {
    const index = this.tabTargets.indexOf(event.currentTarget)
    const destinations = { ArrowRight: (index + 1) % this.tabTargets.length, ArrowLeft: (index + this.tabTargets.length - 1) % this.tabTargets.length, Home: 0, End: this.tabTargets.length - 1 }
    if (!(event.key in destinations)) return
    event.preventDefault()
    this.select(destinations[event.key])
    this.tabTargets[destinations[event.key]].focus()
  }

  select(index) {
    this.tabTargets.forEach((tab, i) => {
      tab.setAttribute("aria-selected", String(i === index))
      tab.tabIndex = i === index ? 0 : -1
    })
    this.panelTargets.forEach((panel, i) => { panel.hidden = i !== index })
  }
}
